import { render, staticRenderFns } from "./offersForTodayCards.vue?vue&type=template&id=cbeb6c56&"
import script from "./offersForTodayCards.vue?vue&type=script&lang=js&"
export * from "./offersForTodayCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports